import axios from "axios";
import { APIResponse, IQuestion } from "../interfaces";

export async function findAllTopQuestions(hostApi: string, idQS: number, i18nId: number, idShop: number): Promise<APIResponse<IQuestion[]>> {
  const response = await axios.get(`${hostApi}/shops/${idShop}/langs/${i18nId}/question-sections/${idQS}/questions/tops`);
  return response.data;
}

export async function findAllQuestionsByIdQS(hostApi: string, idQS: number, i18nId: number, idShop: number): Promise<APIResponse<IQuestion[]>> {
  const response = await axios.get(`${hostApi}/shops/${idShop}/langs/${i18nId}/question-sections/${idQS}/questions`);
  return response.data;
}

export async function findOneQuestion(hostApi: string, id: number, idQS: number, i18nId: number, idShop: number): Promise<APIResponse<IQuestion>> {
  const response = await axios.get(`${hostApi}/shops/${idShop}/langs/${i18nId}/question-sections/${idQS}/questions/${id}`);
  return response.data;
}

export async function fetchSearch(hostApi: string, i18nId: number, shopId: number, searchVal: string): Promise<any[]> {
  const response = await axios.get(`${hostApi}/shops/${shopId}/faq/langs/${i18nId}/search/?search=${searchVal}`);
  return response.data;
}